import React from 'react';
import './TimelineItem.scss';
import Reveal from '../Reveal/Reveal';

// Single entry in the chapter history ledger timeline.
// Rendered as a scannable row (date / title / description) rather than a stacked card.
// Staggers into view via the shared Reveal system, one row per `index` step.
function TimelineItem({ date, title, description, index }) {
    return (
      <Reveal as="div" variant="rise" index={index} className="ledger-row">
          <span className="ledger-row-marker" aria-hidden="true">
            <span className="ledger-row-dot" />
          </span>
          <div className="ledger-row-content">
              <div className="ledger-row-date">{date}</div>
              <div className="ledger-row-title">{title}</div>
              <div className="ledger-row-description">{description}</div>
          </div>
      </Reveal>
    );
}

export default TimelineItem;
